import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { ProductRateStructureJson } from "../../DynamicFormsJson/Transaction/productRateStructure";
import { getAllActiveProductForAssignation } from "../../Slice/product.slice";
import { withRouter } from "../../components/withRouter";
import {
  addAtleastOneRecordMsg,
  noInternetMsg,
  saveFailedMsg,
  saveWarningMsg,
  savemsg,
  serverMsg,
  updateData,
  updateMsg,
} from "../../config/messageconstant";

import dayjs from "dayjs";
import swal from "sweetalert";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { mandatoryCheck } from "../../config/ValidationCheck";
import endpoint from "../../config/endpoints";
import { apiGet, apiPost } from "../../utils/api_service";
import "./product.css";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { redColor } from "../../config/ColorObj";
import ProductRateStructureTable from "./ProductRateStructureTable";
class ProductRateStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matrixDataList: [],
      fieldData: {},
      editData: "",
      formErrors: {},
      isLog: true,
      moduleObjDataObj: {},
      searchValueForProductRateStructure: "",
    };
  }

  async componentDidMount() {
    const {
      getAllActiveProductForAssignation,
      getStockStakeHolderType,
      stakeHolderTypeList,
      showLoador,
      showNotification,
      productList,
    } = this.props;
    if (navigator.onLine) {
      const moduleObjData = localStorage.getItem("moduleObj");
      const moduleObjDataObj =
        moduleObjData != null ? JSON.parse(moduleObjData) : {};


      let isReverseTrue = true;

      const storedValue = localStorage.getItem("showReverseSequenceForProductRateStructure");

      if (storedValue !== null) {
        isReverseTrue = storedValue == 0;
      }


      this.setState({ moduleObjDataObj });

      showLoador({ loador: true });
      await getAllActiveProductForAssignation().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          showLoador({ loador: true });
          getStockStakeHolderType({ userTypeIds: 2, reverseTrue: isReverseTrue }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                if (this.props.params.id) {
                  showLoador({ loador: true });
                  apiGet({
                    url:
                      endpoint.productRateStructure +
                      "/" +
                      this.props.params.id,
                  }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                      showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                      this.matrixEditData(data.data);
                    }
                  });
                } else {
                  this.matrixData();
                }
              }
            }
          );
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  matrixEditData = (data) => {
    const { productList, stakeHolderTypeList } = this.props;
    let newDataToSet = productList?.activeAllProduct.map((productObject) => {
      let filterData = data.productMrpHolderWiseRates.filter(
        (row) => row.product != null && row.product.id == productObject.id
      );
      if (filterData.length !== 0) {
        let matrixObject = {
          productId: productObject.id,
          brandName: productObject.group.brand.name,
          productName: productObject.name,
          categtoryName: productObject.group.subCategory.category.name,
          mrp: filterData[0].mrp,
          outletRate: filterData[0].outletRate,
          expiryRate:
            filterData[0].expiryRate !== null ? filterData[0].expiryRate : 0,

          productObject: productObject,
          uomConversion: productObject.uomConversionValue,
        };
        stakeHolderTypeList?.stockStakeHolderType.map((stakeholderObejct) => {
          let stakeHolderData = filterData[0].dtoTypeWiseRates.filter(
            (row) => row.stockStakeHolderType.id == stakeholderObejct.id
          );
          if (stakeHolderData.length !== 0) {
            matrixObject = {
              ...matrixObject,
              [stakeholderObejct.name.replaceAll(" ", "").toLowerCase()]:
                stakeHolderData[0].rate,
              [stakeholderObejct.name.replaceAll(" ", "").toLowerCase() + "Id"]:
                stakeholderObejct.id,
            };
            return matrixObject;
          } else {
            matrixObject = {
              ...matrixObject,
              [stakeholderObejct.name.replaceAll(" ", "").toLowerCase()]: 0,
              [stakeholderObejct.name.replaceAll(" ", "").toLowerCase() + "Id"]:
                stakeholderObejct.id,
            };
            return matrixObject;
          }
        });
        return matrixObject;
      } else {
        let matrixNewObject = {
          productId: productObject.id,
          brandName: productObject.group.brand.name,
          productName: productObject.name,
          categtoryName: productObject.group.subCategory.category.name,
          mrp: 0,
          outletRate: 0,
          expiryRate: 0,
          productObject: productObject,
          uomConversion: productObject.uomConversionValue,
        };
        stakeHolderTypeList?.stockStakeHolderType.map((stakeholderObejct) => {
          matrixNewObject = {
            ...matrixNewObject,
            [stakeholderObejct.name.replaceAll(" ", "").toLowerCase()]: 0,
            [stakeholderObejct.name.replaceAll(" ", "").toLowerCase() + "Id"]:
              stakeholderObejct.id,
          };
          return matrixNewObject;
        });
        return matrixNewObject;
      }
    });
    this.setState({
      matrixDataList: newDataToSet,
      fieldData:
        this.props.copyFlag == 1
          ? {
            ...data,
            structureName: data.name,
            structureDate: dayjs(data.structureDate, "DD-MM-YYYY"),
          }
          : {
            ...data,
            structureName: data.name,
            structureDate: dayjs(data.structureDate, "DD-MM-YYYY"),
          },
      editData: data,
      DataToSet: [
        {
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          label: "Structure Name",
          value: data.name !== null ? data.name : "",
        },
        {
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          label: "Structure Date",
          value: data.structureDate !== null ? data.structureDate : "",
        },
      ],
    });
  };
  matrixData = () => {
    const { productList, stakeHolderTypeList } = this.props;
    let newDataToSet = productList?.activeAllProduct.map((productObject) => {
      let matrixObject = {
        productId: productObject.id,
        brandName: productObject.group.brand.name,
        productName: productObject.name,
        categtoryName: productObject.group.subCategory.category.name,
        mrp: 0,
        outletRate: 0,
        expiryRate: 0,
        productObject: productObject,
        uomConversion: productObject.uomConversionValue,
      };
      stakeHolderTypeList?.stockStakeHolderType.map((stakeholderObejct) => {
        matrixObject = {
          ...matrixObject,
          [stakeholderObejct.name.replaceAll(" ", "").toLowerCase()]: 0,
          [stakeholderObejct.name.replaceAll(" ", "").toLowerCase() + "Id"]:
            stakeholderObejct.id,
        };
        return matrixObject;
      });
      return matrixObject;
    });
    this.setState({
      matrixDataList: newDataToSet,
    });
  };
  checkValidationOnSubmit = () => {
    const { fieldData, flag } = this.state;
    const { category } = this.props;
    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: ProductRateStructureJson.fieldMeta,
    });
    this.setState({
      formErrors: mandatoryCheckErrors.formErrors,
    });

    return mandatoryCheckErrors.formValid;
  };
  onSubmitHandler = () => {
    const { matrixDataList, fieldData, editData, isLog, moduleObjDataObj } =
      this.state;
    if (
      (editData != "" && this.props.copyFlag == 0) ||
      this.checkValidationOnSubmit()
    ) {
      const { stakeHolderTypeList, showLoador, showNotification } = this.props;

      const isShowProductRateStructureValidation = localStorage.getItem("showValidationAtProductRateStructure");

      let isError = false;
      let newData = [];

      let matData = matrixDataList.map((matrixObject) => {
        let updatedMatrix = {
          ...matrixObject,
          superstockistError: false,
          distributorError: false,
          subdistributorError: false,
          outletRateError: false,
          stockistError: false,
          mrpError: false
        };

        if (updatedMatrix.mrp === "") {
          updatedMatrix.mrpError = true;
          isError = true;
        }

        if (updatedMatrix.superstockist === "" || updatedMatrix.distributor === ""
          || updatedMatrix.outletRate === "") {
          isError = true;
        }

        if (isShowProductRateStructureValidation !== null && isShowProductRateStructureValidation == 1) {
          // Validation 1: superstockist should be less than distributor
          const superstockistValue = parseFloat(updatedMatrix.superstockist || 0);
          const distributorValue = parseFloat(updatedMatrix.distributor || 0);

          if (updatedMatrix.superstockist !== "" && updatedMatrix.distributor !== "" &&
            superstockistValue > 0 && distributorValue > 0) {
            if (superstockistValue > distributorValue) {
              updatedMatrix.superstockistError = true;
              isError = true;
            }
          }

          //If sub distributor 
          if (updatedMatrix.subdistributor && updatedMatrix.subdistributor !== null) {

            //Validation - distributor should be less than sub distributor 
            const distributorValues = parseFloat(updatedMatrix.distributor || 0);
            const subDistributorValue = parseFloat(updatedMatrix.subdistributor || 0);

            if (updatedMatrix.distributor !== "" && updatedMatrix.subdistributor !== "" &&
              distributorValues > 0 && subDistributorValue > 0) {
              if (distributorValues > subDistributorValue) {
                updatedMatrix.distributorError = true;
                isError = true;
              }
            }

            // Validation - Sub distributor should be less than (outletRate * uomConversion)
            const subDistributorVal = parseFloat(updatedMatrix.subdistributor || 0);
            const outletRateValues = parseFloat(updatedMatrix.outletRate || 0);
            const uomConversionValues = parseFloat(updatedMatrix.uomConversion || 1);

            if (updatedMatrix.subdistributor !== "" && updatedMatrix.outletRate !== "" &&
              subDistributorVal > 0 && outletRateValues > 0) {
              const outletRateConverted = outletRateValues * uomConversionValues;
              if (subDistributorVal > outletRateConverted) {
                updatedMatrix.subdistributorError = true;
                isError = true;
              }
            }
          }

          // Validation 2: distributor should be less than (outletRate * uomConversion)
          const distributorVal = parseFloat(updatedMatrix.distributor || 0);
          const outletRateVal = parseFloat(updatedMatrix.outletRate || 0);
          const uomConversionValue = parseFloat(updatedMatrix.uomConversion || 1);

          if (updatedMatrix.distributor !== "" && updatedMatrix.outletRate !== "" &&
            distributorVal > 0 && outletRateVal > 0) {
            const outletRateConverted = outletRateVal * uomConversionValue;
            if (distributorVal > outletRateConverted) {
              updatedMatrix.distributorError = true;
              isError = true;
            }
          }

          // Validation 3: outletRate should be less than mrp
          const outletRateValue = parseFloat(updatedMatrix.outletRate || 0);
          const mrpValue = parseFloat(updatedMatrix.mrp || 0);

          if (updatedMatrix.outletRate !== "" && updatedMatrix.mrp !== "" &&
            outletRateValue > 0 && mrpValue > 0) {
            if (outletRateValue >= mrpValue) {
              updatedMatrix.outletRateError = true;
              isError = true;
            }
          }

        }

        // Build data to save only if MRP is valid
        if (updatedMatrix.mrp != 0 && !updatedMatrix.mrpError) {
          let dataToSave = {
            mrp: updatedMatrix.mrp === "" ? 0 : updatedMatrix.mrp,
            product: updatedMatrix.productObject,
            outletRate:
              updatedMatrix.outletRate === "" ? 0 : updatedMatrix.outletRate,
            expiryRate:
              localStorage.getItem(
                "radioPurchasereturnAndExpiryForRatestructure"
              ) &&
                localStorage.getItem(
                  "radioPurchasereturnAndExpiryForRatestructure"
                ) == 1
                ? updatedMatrix.expiryRate !== "" &&
                  updatedMatrix.expiryRate !== null
                  ? updatedMatrix.expiryRate
                  : 0
                : 0,
            dtoTypeWiseRates: stakeHolderTypeList?.stockStakeHolderType.map(
              (stakeholderObejct) => {
                return {
                  rate:
                    updatedMatrix[
                    stakeholderObejct.name.replaceAll(" ", "").toLowerCase()
                    ] || "0",
                  stockStakeHolderType: {
                    id: stakeholderObejct.id,
                  },
                };
              }
            ),
          };
          newData.push(dataToSave);
        }

        return updatedMatrix;
      });

      this.setState({
        matrixDataList: matData
      });

      if (isError) {
        return showNotification({
          msg: "Invalid Rate - Please check all fields",
          severity: "error",
        });
      }



      if (newData.length != 0) {
        let jsonToSave = {};
        console.log(newData);
        if (this.props.params.id && this.props.copyFlag == 0) {
          jsonToSave = {
            name: fieldData.structureName,
            structureDate: fieldData.structureDate.format("DD-MM-YYYY"),
            id: this.props.params.id,
            json: JSON.stringify(newData),
          };
        } else {
          jsonToSave = {
            name: fieldData.structureName,
            structureDate: fieldData.structureDate.format("DD-MM-YYYY"),
            json: JSON.stringify(newData),
          };
        }

        swal({
          title: "Are you sure?",
          text: this.props.params.id ? updateData : saveWarningMsg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            showLoador({ loador: true });
            apiPost({
              url: endpoint.productRateStructure,
              postBody: jsonToSave,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (success) {
                if (isLog) {
                  if (data.data !== null) {
                    let updatedJsonToSend = JSON.stringify(data.data);

                    let dataToSaveForMLog = {
                      module: {
                        moduleId: moduleObjDataObj.moduleId,
                      },
                      subModule: {
                        subModuleId: moduleObjDataObj.subModuleId,
                      },
                      operationType: this.props.params.id ? 1 : 0,
                      type: 1,
                      operationPerformId: data.data.id,
                      updatedJson: updatedJsonToSend,
                    };

                    showLoador({ loador: true });
                    apiPost({
                      url: endpoint.mlog,
                      postBody: dataToSaveForMLog,
                    }).then(({ success }) => {
                      showLoador({ loador: false });
                      if (success) {
                      } else {
                        showNotification({
                          msg: saveFailedMsg,
                          severity: "error",
                        });
                      }
                    });
                  }
                }

                if (this.props.params.id) {
                  this.props.navigate(-1);
                  showNotification({
                    msg: updateMsg,
                  });
                } else {
                  this.props.changeTab(1, data);
                  showNotification({
                    msg: savemsg,
                  });
                }
              } else {
                showNotification({ msg: saveFailedMsg, severity: "error" });
              }
            });
          }
        });
      } else {
        if (newData.length == 0) {
          showNotification({
            msg: addAtleastOneRecordMsg,
            severity: "error",
          });
        }
      }
    }
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData } = this.state;
    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    ProductRateStructureJson.fieldMeta.map((currentField) => {
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");

        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });

        this.getListById(dataToSearch);
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      return null;
    });
    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  onSearchProductRateStructure = (searchValueForProductRateStructure) => {
    this.setState({
      searchValueForProductRateStructure: searchValueForProductRateStructure,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValueForProductRateStructure } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["brandName"] &&
          currentRow["brandName"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["productName"] &&
          currentRow["productName"]
            .toString()
            .toLowerCase()
            .includes(
              searchValueForProductRateStructure.trim().toLowerCase()
            )) ||
        (currentRow["categtoryName"] &&
          currentRow["categtoryName"]
            .toString()
            .toLowerCase()
            .includes(searchValueForProductRateStructure.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onChange = (e, productObject) => {
    const { matrixDataList } = this.state;
    const { name, value } = e.target;
    const regex = /^\d*\.?\d{0,2}$/;

    let isShowProductRateStructureValidation = localStorage.getItem("showValidationAtProductRateStructure");


    if (regex.test(value)) {
      let newMatrixData = matrixDataList.map((matrixObject) => {
        if (matrixObject.productId == productObject.productId) {
          let newData = {
            ...matrixObject,
            [name]: value,
            outletRateError: false,
            superstockistError: false,
            distributorError: false,
            stockistError: false,
            subdistributorError: false,
          };

          if (isShowProductRateStructureValidation !== null && isShowProductRateStructureValidation == 1) {
            // Validation 1: superstockist should be less than distributor
            const superstockistValue = parseFloat(newData.superstockist || 0);
            const distributorValue = parseFloat(newData.distributor || 0);

            if (newData.superstockist !== "" && newData.distributor !== "" &&
              superstockistValue > 0 && distributorValue > 0) {
              if (superstockistValue > distributorValue) {
                newData.superstockistError = true;
              }
            }

            //If sub distributor 
            if (newData.subdistributor && newData.subdistributor !== null) {

              //Validation - distributor should be less than sub distributor 
              const distributorValues = parseFloat(newData.distributor || 0);
              const subDistributorValue = parseFloat(newData.subdistributor || 0);

              if (newData.distributor !== "" && newData.subdistributor !== "" &&
                distributorValues > 0 && subDistributorValue > 0) {
                if (distributorValues > subDistributorValue) {
                  newData.distributorError = true;
                }
              }

              // Validation - Sub distributor should be less than (outletRate * uomConversion)
              const subDistributorVal = parseFloat(newData.subdistributor || 0);
              const outletRateValues = parseFloat(newData.outletRate || 0);
              const uomConversionValues = parseFloat(newData.uomConversion || 1);

              if (newData.subdistributor !== "" && newData.outletRate !== "" &&
                subDistributorVal > 0 && outletRateValues > 0) {
                const outletRateConverted = outletRateValues * uomConversionValues;
                if (subDistributorVal > outletRateConverted) {
                  newData.subdistributorError = true;
                }
              }
            }


            // Validation 2: distributor should be less than (outletRate * uomConversion)
            const distributorVal = parseFloat(newData.distributor || 0);
            const outletRateVal = parseFloat(newData.outletRate || 0);
            const uomConversionValue = parseFloat(newData.uomConversion || 1);

            if (newData.distributor !== "" && newData.outletRate !== "" &&
              distributorVal > 0 && outletRateVal > 0) {
              const outletRateConverted = outletRateVal * uomConversionValue;
              if (distributorVal > outletRateConverted) {
                newData.distributorError = true;
              }
            }

            // Validation 3: outletRate should be less than mrp
            const outletRateValue = parseFloat(newData.outletRate || 0);
            const mrpValue = parseFloat(newData.mrp || 0);

            if (newData.outletRate !== "" && newData.mrp !== "" &&
              outletRateValue > 0 && mrpValue > 0) {
              if (outletRateValue >= mrpValue) {
                newData.outletRateError = true;
              }
            }

          }
          return newData;
        } else {
          return matrixObject;
        }
      });

      this.setState({
        matrixDataList: newMatrixData,
      });
    }
  };

  render() {
    const { formErrors, DataToSet, matrixDataList, fieldData } = this.state;
    const { productList, stakeHolderTypeList } = this.props;

    const isReverse = localStorage.getItem("showReverseSequenceForProductRateStructure");

    return (
      <>
        <DynamicFormWithoutValidation
          showBackToList={true}
          showTitle={ProductRateStructureJson.showTitle}
          screenTitle={""}
          apiBaseURL={ProductRateStructureJson.apiBaseURL}
          fieldMeta={ProductRateStructureJson.fieldMeta}
          showCancel={ProductRateStructureJson.showCancel}
          showSaveNextBtn={ProductRateStructureJson.showSaveNextBtn}
          saveBtnText={"Search"}
          showSaveBtnMain={false}
          showSaveBtn={false}
          fieldData={fieldData}
          formErrors={formErrors}
          onDataChange={this.onDataChange}
        />

        <br />
        <LandingScreenHeader
          screenTitle={""}
          showSearchBox={true}
          showTable={true}
          showFilter={false}
          showPdfDownload={false}
          showExcelDownload={false}
          onSearch={this.onSearchProductRateStructure}
        />
        <br />

        <ProductRateStructureTable
          matrixDataList={matrixDataList}
          stockHolderTypeList={stakeHolderTypeList?.stockStakeHolderType}
          onChange={this.onChange}
          getFilteredTableData={this.getFilteredTableData}
        />

        <br />
        <Grid
          item
          sm={12}
          xs={12}
          md={12}
          lg={12}
          rowSpacing={2}
          columnSpacing={{ xs: 12, sm: 6, md: 1 }}
          container
          justifyContent="right"
        >
          <ButtonCompo
            size="medium"
            type="submit"
            variant="contained"
            name="Submit"
            onClick={this.onSubmitHandler}
          />
        </Grid>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  multipleStockList: state.manageStockByDate,
  stakeHolderTypeList: state.stockStakeHolderType,
  productList: state.product,
});
const mapDispatchToProps = {
  getAllActiveProductForAssignation,
  getStockStakeHolderType,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ProductRateStructure);
